export default __webpack_public_path__ + "static/media/gallery_05.f76d0fa8.jpg";